import { ChevronRight } from '@styled-icons/heroicons-outline/ChevronRight';
import { MatchesModalSchema } from '@/views/sports/components/MatchesModal/styles/MatchesModal.styles';

export const matchesModalStyles: MatchesModalSchema = {
  modalWrapper: { size: 'lg', isCentered: true, scrollBehavior: 'inside' },
  modalContent: {
    color: 'gamma.500',
    overflow: 'hidden',
    bg: 'alpha.600',
    boxShadow:
      '0px 6px 10px 0px rgba(0, 0, 0, 0.2), 0px 0px 0px 2px rgba(255, 192, 51, 1) inset, 0px 0px 0px 3px rgba(255, 255, 255, 0.6) inset, 0px 0px 0px 3px rgba(117, 20, 16, 1) inset',
  },
  modalHeader: {
    alignItems: 'center',
    borderBottom: '1px',
    borderColor: 'blackAlpha.300',
    display: 'flex',
    gap: '4',
    justifyContent: 'space-between',
    p: '4',
    fontWeight: 'medium',
    fontSize: 'lg',
  },
  closeButton: {
    bg: 'gamma.200',
    color: 'alpha.600',
    isRound: true,
    p: '1',
    size: 'xs',
    variant: 'link',
    _hover: { bg: 'gamma.500' },
  },
  divider: { as: 'div', borderColor: 'blackAlpha.300' },
  modalBody: { p: '0', maxH: '400px' },
  stackWrapper: { spacing: '0' },
  linkWrapper: {
    alignItems: 'center',
    display: 'flex',
    gap: '3',
    justifyContent: 'space-between',
    p: '3',
    mx: '3px',
    _last: { mb: '3px' },
    _hover: { bg: 'alpha.500', textDecoration: 'none' },
  },
  flexSportName: {
    align: 'center',
    fontSize: 'sm',
    fontWeight: 'medium',
    gap: '1',
    color: 'gamma.200',
  },
  iconSportName: { fontSize: '2xl', color: 'gamma.500' },
  hStack: { spacing: '1' },
  countdown: {
    color: 'inherit',
    fontSize: '9px',
    h: '16px',
    py: '0',
    sx: {
      '&&': {}, // Reset
      ':not(.state-prior)': { color: 'white' },
    },
  },
  duotoneSgmLogoOverride: {
    h: 'auto',
    w: '9',
  },
  hStackIcon: {
    as: ChevronRight,
    color: 'gamma.200',
    fontSize: '2xl',
  },
};
